import styled from 'styled-components';

export const Wrapper = styled.div`
  margin: 8px 0;
  max-width: 100%;
`;

export const LabelElement = styled.label`
  font-family: inherit;
  font-size: inherit;
`;

export const DropdownWrapper = styled.div`
  position: relative;
  margin-top: 8px;
`;

export const TriggerButton = styled.button`
  width: 100%;
  text-align: left;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  min-height: 40px;
  padding: 8px 12px;
  background: #fff;
  border: 1px solid #0b1f1c7a;
  border-radius: 4px;
  font-family: inherit;
  font-size: inherit;

  &:focus-visible {
    outline: 2px solid #0b1f1c;
    outline-offset: 2px;
  }
`;

export const Dropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  margin-top: 4px;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  z-index: 10;
  max-height: 220px;
  overflow-y: auto;
  padding: 8px;
`;

export const OptionRow = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  cursor: pointer;
  user-select: none;
`;
